<template>
  <div class="edit-deliverable-modal" :class="(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly) ? 'read-only' : ''" v-show="deliverableDetail">
  	<div class="deliverable-project-on-hold-header" v-if="isParentProjectOnHold(deliverableDetail.project_id)">
  	  <div class="icon-wrapper"><img :src="require(`@/csmworkflow/img/project-on-hold-icon.svg`)" /></div>
  	  <h1>Project On Hold - {{deliverableDetail.project_id.name}}</h1>
  	</div>
    <div class="departments__wrapper">
      <!-- Deliverable type -->
   <DeliverableDropdown
        :deliverable="deliverableDetail"
        :deliverableTypes="deliverableTypes"
        :classNames="'department-title'"/>

      <DeliverableDepartments v-if="isMobile() && showDepartment()" :deliverable="deliverableDetail" :namespace="namespace"/>
      <DeliverableProjects :deliverable="deliverableDetail" :namespace="namespace" />
    </div>
    <label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
      <h1
      @click="activateTitleField"
      class="exclude-outside-click edit-d-title deliverable-title"
      v-show="!editTitle"
      >{{ deliverableDetail.title || 'Click to set...' }}</h1>
      <textarea
      v-click-outside="outside"
      ref="deliverableTitle"
      v-show="editTitle"
      v-model="deliverableDetail.title"
      type="text"
       :placeholder="getDeliverableTitlePlaceholder"
      class="form-control mb-3 title-field exclude-outside-click h1"
      @change="updateDeliverableTitle"
        @blur="editTitle=false;"></textarea>
    </label>
    <div class="row">
      <div class="col-md-5">
        <DeliverableDepartments v-if="!isMobile() && showDepartment()" :deliverable="deliverableDetail" :namespace="namespace" />
        <label v-if="!isMobile()" class="form-group w-100">
          <h1
          @click="activateTitleField"
          class="exclude-outside-click edit-d-title deliverable-title"
          v-show="!editTitle"
          >{{ deliverableDetail.title || 'Click to set...' }}</h1>
          <textarea
          v-click-outside="outside"
          ref="deliverableTitle"
          v-show="editTitle"
          v-model="deliverableDetail.title"
          type="text"
          :placeholder="getDeliverableTitlePlaceholder"
          class="form-control mb-3 title-field exclude-outside-click h1"
          @change="updateDeliverableTitle"
            @blur="editTitle=false;"></textarea>
        </label>
      </div>
      <div class="col-md-7">
        <div class="form-group">
          <div class="tags__wrapper">
            <DeliverableListTags :deliverable="deliverableDetail"
              :namespace="namespace"
              @tag-created="updateDeliverableTags" />
          </div>
          <div class="trending-tags" v-if="relatedTags.length">
            <label>Trending tags:</label>
            <a
            href="#"
            @click.prevent="setTag(relatedTag)"
            class="badge badge-success ml-2"
            v-for="(relatedTag, index) in relatedTags"
            :key="'relate-tag'+index"
            >{{ relatedTag.name }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8">

            <div class="row no-gutters">
            	  <div class="col-md-12">
            	    <div
            	    class="field-box"
            	    v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'social_media_plan_details'})"
            	    :key="index"
            	    >
            	    <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
            	  </div>
            	</div>
              <div class="col-md-12">
                <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'questions'})"
                :key="index"
                >
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>
            <div class="col-md-12">
              <div
              class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'responses'})"
              :key="index"
              >
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
            </div>
          </div>
          <div class="col-md-12">
            <div
            class="field-box"
            v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'notes_research'})"
            :key="index"
            >
            <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
          </div>
        </div>

            <div class="col-md-12">
              <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'location_text'})"
                :key="index"
                >
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters" >
            <div class="col-md-12">
              <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'priority'})"
                :key="index"
                >
                <DeliverableCustomFields 
                :deliverable="deliverableDetail" 
                :customField="field" 
                :namespace="namespace" 
                @priority-updated="onDeliverablePriorityUpdated" />
              </div>
            </div>

            <div class="col-md-6" style="padding-right:10px;">
              <div class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'start_date' })"
                :key="index">

                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>
            <div class="col-md-6" style="padding-left:10px;">
              <div class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'end_date' })"
                :key="index">
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>

            <div class="col-md-12">
              <div class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'start_datetime' })"
                :key="index">

                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>
            <div class="col-md-12">
              <div class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'end_datetime' })"
                :key="index">
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
              </div>
            </div>

            <div class="col-md-12">
                <div
                  class="field-box"
                  v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'publish_datetime'})"
                  :key="index"
                  >
                  <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
                </div>
              </div>

            <div class="col-md-12">
              <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.templateCustomFields, {field_key: 'marketing_officer'})"
                :key="index"
                >
                  <DeliverableCustomFields 
                  :deliverable="deliverableDetail" 
                  :customField="field" 
                  :namespace="namespace"/>
              </div>
            </div>

            <div class="col-md-12">
              <b-tabs class="field-tabs" content-class="field-tab-content" fill v-model="currentTab">
                <b-tab class="field-tab-research field-box" active title="Contact" v-if="hasContactFields()" >
                  <DeliverableContact :deliverableDetail="deliverableDetail" />
                </b-tab>
                <b-tab class="field-tab-chat" :lazy="lazyLoadChat" title="Chat" v-if="hasChat()" @click="turnOffLazy">
                  <div class="chat-wrapper">
                    <Chat 
                    :primaryParticipantId="deliverableDetail.id" 
                    :primaryParticipantTitle="deliverableDetail.title" 
                    :primaryParticipantType="deliverableDetail.deliverable_template_id" 
                    :chatNamespace="'deliverableChat'"
                    :shouldRefreshMessages="currentTab == 1"
                    />
                  </div>
                </b-tab>
            </b-tabs>
          </div>

          <div class="col-md-12">
            <div
              class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'website'})"
              :key="index"
              >
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
            </div>
          </div>

          <div class="col-md-6" style="padding-right:10px;">
            <div class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'interview_given' })"
              :key="index">
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
            </div>
          </div>

          <div class="col-md-6" style="padding-right:10px;">
            <div class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'referred_to_external' })"
              :key="index">
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace"/>
            </div>
          </div>

          <div class="col-md-12">
            <div class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'french_request' })"
              :key="index">
              <DeliverableCustomFields
              :deliverable="deliverableDetail"
              :customField="field"
              :namespace="namespace"
               />
            </div>
          </div>

          <div class="col-md-12">
            <div class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'language' })"
              :key="index">
              <DeliverableCustomFields 
              :deliverable="deliverableDetail" 
              :customField="field" 
              :namespace="namespace"
               />
            </div>
          </div>








  <div class="col-md-12 field-box">
    <div class="field-box__header">
      <div class="dropdown">
        <button
        v-b-tooltip.hover
        title="Add resource"
        class="add-resource-button exclude-outside-click d-inline-block"
        data-toggle="dropdown" aria-expanded="false"
        data-reference="parent"
        >Resources</button>
        <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
        <div class="dropdown-menu deliverable-resource-type-menu">
          <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
        </div>
      </div>
    </div>
      <div class="field-box__content">
          <div class="resource-box"
          v-for="(resource, index) in _.filter(deliverableDetail.customFields, {field_key: 'link_url'})"
          :key="'link_url-'+index"
          >
          <div class="media">
            <img class="link-type-icon" style="margin-right: 3px" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.id)).icon}`)" draggable="false">
            <div class="media-body">
              <div class="resource-box__url"></div>
                <a v-if="resource.value" :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="_blank" :id="`resource-${index}`">{{customChildFieldValue('link_label',resource.id) || resource.value}}</a>
                <b-tooltip :target="`resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:'var(--wf-primary)';"></i> Link Copied!</b-tooltip>
                <a v-if="!resource.value" :href="getResourceHref(resource.value,resource.id)" target="_blank" 
                :id="`resource-${index}`" @click="setCookieForDownload"
                >{{customChildFieldValue('link_label',resource.id) || resource.value}}</a>
                <a
                v-b-tooltip.hover
                title="Edit resource"
                class="edit-resource-btn"
                href="#"
                v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                @click.prevent="editResource(resource)"
                >
                <i class="fas fa-edit"></i>
              </a>
              <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.id)">{{customChildFieldValue('link_notes',resource.id)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>




</div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3"></div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="add-task-button-mobile">
      <b-button v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)" variant="theme" class="add-task-btn" @click.stop="createTask">
          Add Task
          <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
      </b-button>
    </div>
    <TaskFieldLabels ref="TaskFieldLabelsRef" :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" :namespace="namespace"/>
    <TaskFields :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" :namespace="namespace"/>
  </div>
</div>

<div :class="showModalOptions ? 'open' : ''" class="responsive-edit-modal-controls">
  <button
  v-b-tooltip.hover
  title="More options"
  @click="showModalOptions=!showModalOptions"
  class="btn modal-more-controls"
  >
    <i class="fas" :class="!showModalOptions ? 'fa-arrow-left' : 'fa-arrow-right'"></i>
  </button>



  <button
  v-b-tooltip.hover
  :title="getDeleteDeliverableTitle"
  @click="removeDeliverable(deliverableDetail.deliverableId)"
  class="btn delete-deliverable-btn"
  v-if="userAbilities.deleteMediaCall && !deliverableDetail.permissions.viewOnly"
  >
    <i class="fas fa-trash-alt"></i>
  </button>

  <DuplicateMediaCallBtn :deliverableId='deliverableDetail.deliverableId' :namespace="namespace"  :deliverableTemplateId="deliverableDetail.deliverable_template_id"/>
  <FeedbackBtn />
  <button
  v-b-tooltip.hover
  title="Close"
  @click="onCloseModal"
  class="btn close-deliverable-btn"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
<b-modal v-model="showRemoveDeliverable" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable" ok-title="Yes, Delete">
  <p>Are you sure you want to delete this deliverable?</p>
</b-modal>
<b-modal v-model="showRemoveContact" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveContact" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this contact?</p>
</b-modal>

<b-modal v-model="showRemoveSpokesperson" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveSpokesperson" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this spokesperson?</p>
</b-modal>
<b-modal v-model="showRemoveWho" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveWho" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this outlet?</p>
</b-modal>


<b-modal centered no-close-on-backdrop hide-footer id="createLinkModal" title="New Resource / Link" @shown="focusLinkModal">
  <CreateLinkModal ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
    v-bind:link-notes="linkNotes" v-bind:link-type="linkType" :is-file="editLinkIsFile"
    :resource-parent="'deliverable'" :namespace="namespace" />
</b-modal>
<b-modal centered no-close-on-backdrop hide-footer id="editLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
  <EditLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" :namespace="namespace"/>
</b-modal>
<b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
  <LinkCopyLinkModal :linkUrl="linkCopyModalValue" :namespace="namespace" />
</b-modal>

</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import toast from "../../toast";
import Format from "../../utility/Format";
import DeliverableCustomFields from "../common/DeliverableCustomField";
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import FeedbackBtn from "../common/FeedbackBtn";
import FullContactField from "../common/FullContactField";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import Chat from "./Chat.vue";
import CreateLinkModal from "./CreateLinkModal";
import DeliverableContact from "./DeliverableContact";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableDropdown from "./DeliverableDropdown";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import UpdateContactModal from "./EditContactModal";
import EditLinkModal from "./EditLinkModal";
import TaskFieldLabels from "./TaskFieldLabels";
import TaskFields from "./TaskFields";

export default {
  data() {
    return {
      currentTab: 0,
    	namespace:"", // TODO: make namespace a prop instead.
      Format,
      showModalOptions: false,
      renderCount: 1,
      newContactId: "",
      newContactName: "",
      editTitle: false,
      addingTask: true,
      addContactFlag: false,
      showRemoveDeliverable: false,
      showRemoveContact:false,
      showRemoveSpokesperson:false,
      showRemoveWho:false,
      showRemoveResource:false,
      addResourceFlag:false,
      contacts:[],
      lazyLoadChat: true,
      linkUrl:null,
      linkLabel:null,
      linkNotes:null,
      linkType:null,
      filepond: [],
      editLinkIsFile: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},

    };
  },
  components: {
    Chat,
    DeliverableProjects,
    DeliverableContact,
    DeliverableCustomFields,
    DeliverableDropdown,
    TaskFields,
    TaskFieldLabels,
    UpdateContactModal,
    DeliverableListTags,
    DeliverableDepartments,
    FullContactField,
    EditLinkModal,
    FeedbackBtn,
    DuplicateMediaCallBtn,
    CreateLinkModal,
    LinkCopyLinkModal,
  },
  props: ["allContacts", "modalId", "tabIndex"],
  computed: {
    ...mapGetters([
    "allDepartments",
    "allSubjects",
    "deliverableDetail",
    "allTags",
    "allRegions",
    "allCustomFields",
    "initialContacts",
    "userAbilities",
    "deliverableTypes",
    "getDeliverableTemplateSlug",
    "tasksToHighlight",
    "taskHighlighted",
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    getDeliverableTitlePlaceholder() {
    	if (this.deliverableDetail) {
        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
	    	if (deliverableTemplateSlug == "media-call") {
	    		return "Media call title...";
	    	} else {
          if (deliverableTypeObj) {
            return deliverableTypeObj.name + " title...";
          } else {
            return "Deliverable title...";
          }
	    	}
	    }
    },

    getDeleteDeliverableTitle() {
    	if (this.deliverableDetail) {

        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
	    	if (deliverableTemplateSlug == "media-call") {
	    		return "Delete Media Call";
	    	} else {
          if (deliverableTypeObj) {
            return "Delete " + deliverableTypeObj.name;
          } else {
            return "Delete Deliverable";
          }
	    	}
	    }
    },


    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags;
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function(e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },

    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
		},
  },
  methods: {
    ...mapActions([
    "updateFieldValue",
    "createTag",
    "removeDeliverableContact",
    "removeDeliverableWho",
    "removeDeliverableSpokesperson",
    ]),
    turnOffLazy() {
      // lazyLoadChat = true when modal is opened, no chat related api calls
      // Chat tab is clicked once, chat api calls, roomInfo and messages are loaded
      // turn off lazy loading to avoid api calls whenever tab is clicked again
      this.lazyLoadChat = false;
    },
    updateDeliverableTitle() {
      this.deliverableDetail.title = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
      this.updateFieldValue(this.deliverableDetail);
    },



    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
            this.editTitle = false;
            this.addContactFlag = false;
        },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableContacts.$el.focus();
      });
    },
    showAddResource() {
      this.addResourceFlag = true;
    },
    showDepartment() {
      const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
			return deliverableTemplateSlug != "project-deliverable";
    },

    onContactSearch(input) {
      this.isLoading = true;
      this.contacts = [];
      if (input.length < 1) {
        this.isLoading = false;
      }  else {
        axios.get(process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input))
        .then(resp => {
          this.contacts = [];
          for(var contact of resp.data) {
            contact.name = contact.first_name +  " " + contact.last_name;
            contact.commaName = contact.last_name + ", " + contact.first_name;
            this.contacts.push(contact);
          }
          this.isLoading = false;
        })
      }
    },
    contactCustomLabel ({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },
    getResourceHref(url, parent_id) {
      let label = this.customChildFieldValue('link_label', parent_id);
      let fileId = this.customChildFieldValue('file_id', parent_id);
      if (url == null && fileId != null && label) {
        return `${this.apiUrl}downloadFileDeliverable/${this.deliverableDetail.id}/${fileId}`;
      }
      return "";
    },

      openCopyLinkModal(link, e, i) {
        if (!link.includes("\\")) {
          return;
        }
        e.preventDefault();
        this.copyLink(link, i);
      },
      async copyLink(link, resourceId) {
        clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
        Object.keys(this._.filter(this.deliverableDetail.customFields, {field_key: 'link_url'})).forEach(x => {
          if (x == resourceId) return;
          this.$root.$emit('bv::hide::tooltip', 'resource-' + x);
        })

        const navPer = await navigator.permissions.query({name: "clipboard-write"});
        if (navPer.state == "granted" || navPer.state == "prompt") {
            try {
                await navigator.clipboard.writeText(link);
            } catch {
                console.error("clipboard API error. Cannot copy to clipboard.");
                this.legacyCopyMethod(link);
            }
        } else {
          this.legacyCopyMethod(link);
        }

        this.$root.$emit('bv::show::tooltip', 'resource-' + resourceId);
        this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
          this.$root.$emit('bv::hide::tooltip', 'resource-' + resourceId);
        }, 2000);
      },
      legacyCopyMethod(link) {
        let tempInput = document.createElement("input");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      },


      customChildField(key, parent_id) {
        if (this.deliverableDetail.customFields) {
          let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            // return the global version of the custom field...
            let field = _.filter(this.allCustomFields, {field_key: key});


            if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            	return null;
            } else {
	            obj = {};
	            obj.id = null;
	            obj.parent_id = this.deliverableDetail.customFields[key].id;
	            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
	            obj.editing = false;
	            obj.field_id = field[0].id;
	            obj.field_key = field[0].field_key;
	            obj.field_parent_id = field[0].parent_id;
	            obj.field_type = field[0].field_type;
	            obj.note = field[0].note;
	            obj.value = null;
	            obj.label = field[0].label;
	            obj.value_set = field[0].value_set;
	            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
	           }
	           return [obj];
          }
      }
      return [];
    },


    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj != null) {
	        if (obj.length > 0) {
	          return obj[0].value;
	        } else {
	          return null;
	        }
	      }
      }
      return null;
    },



    createContact(newContactName) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createContactModal");
    },

    editResource(resource) {
      this.linkUrl = resource;
      let label =  this.customChildField('link_label', resource.id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes =  this.customChildField('link_notes', resource.id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type =  this.customChildField('link_type', resource.id);
      if (type && type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id:null,
          field_id:37,
          parent_field_id:20,
          field_key:"link_type",
          field_type:"select",
          parent_id:null,
          deliverable_id:this.deliverableDetail.deliverableId,
          value:1
        };
      }
      let fileId = this.customChildField('file_id', resource.id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editLinkModal");
    },


    addResource(typeId = 1, modalId) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.linkUrl = {
        id:null,
        field_id:20,
        parent_field_id:null,
        field_key:"link_url",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkLabel = {
        id:null,
        field_id:21,
        parent_field_id:20,
        field_key:"link_label",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkNotes = {
        id:null,
        field_id:22,
        parent_field_id:20,
        field_key:"link_notes",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkType = {
        id:null,
        field_id:37,
        parent_field_id:20,
        field_key:"link_type",
        field_type:"select",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:typeId
      };
      this.$bvModal.show(modalId);
    },
    addResourceMenuItemClick(type, e) {
      e.preventDefault();
      let modalId = "createLinkModal";
      if (type.slug == "file") {
        this.editLinkIsFile = true;
      } else {
        this.editLinkIsFile = false;
      }
      this.addResource(type.id, modalId);
    },

    contactsNotAdded(field_key) {
      let addedContacts = _.filter(this.deliverableDetail.customFields, {
        field_key: field_key
      }),
      allContacts = this.allContacts,
      addedIds = [];

      _.forEach(addedContacts, function(n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function(o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },

    addDeliverableContact(payload) {
      this.$store.dispatch("addDeliverableContact", payload);
      this.newContactId = "";
    },
    removeDeliverable(deliverableId) {
      this.showRemoveDeliverable = true;
    },
    onConfirmRemoveDeliverable() {
      if (this.deliverableDetail.deliverableId) {
        let that = this;
        let deliverableTemplateId = this.deliverableDetail.deliverable_template_id;
        this.$store.dispatch("removeDeliverable", { deliverableId:this.deliverableDetail.deliverableId }).then(function() {
          that.$bvModal.hide("editDeliverableModal");
          // TODO: removing a deliverable should only remove it from the list, not replace entire list.
          // that.$store.commit('removeMediaCallFromList', deliverableId);
          // that.$store.dispatch('countOutlets');

          that.$store.dispatch('fetchDeliverables').then(function() {
            toast.hide();

            if (deliverableTemplateId == 1) {
            	that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
            } else {
            	that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
            }

          	that.$store.dispatch('fetchProjectDeliverable');
          });
        });
      }
    },
    showRemoveDeliverableContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableContact(this.contactId);
      }
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },

    onShowRemoveSpokesperson(contactId) {
      this.contactId = contactId;
      this.showRemoveSpokesperson = true;
    },
    onConfirmRemoveSpokesperson() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

    onShowRemoveWho(contactId) {
      this.contactId = contactId;
      this.showRemoveWho = true;
    },
    onConfirmRemoveWho() {
      if (this.contactId) {
        this.removeDeliverableWho(this.contactId);
      }
    },

    onCloseModal() {
        if (this.modalId) {
          this.$bvModal.hide(this.modalId);
        } else {
          this.$bvModal.hide("editDeliverableModal");
        }
        if (
          this.$router.currentRoute.name == 'calendar' ||
          this.$router.currentRoute.name == "projectDeliverable"
        ) {
          this.$root.$emit('re__fetch__calendar__data', this.deliverableDetail)
        }
    },


    setTag(newTag) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch("updateFieldValue", this.deliverableDetail);
    },

    updateDeliverableTags() {
      // update tags on listing when modal is opened on top
      this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    onDeliverablePriorityUpdated(newPriority) {
      // update priority on listing when modal is opened on top
      this.deliverableDetail.priority = newPriority;
    },

    activateTitleField() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      let that = this
      this.editTitle=true;
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    hasChat(){
      let contactCustomFields = _.filter(this.deliverableDetail.templateCustomFields, {field_type: 'chat'});
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },

    isParentProjectOnHold(project_id) {
    	if (
    		project_id &&
    		project_id.project_status &&
    		project_id.project_status.slug &&
    		project_id.project_status.slug == 'on-hold'
    	) {
    		return true;
    	}
    	return false;
    },

    hasContactFields() {
      let contactCustomFields = _.filter(this.deliverableDetail.templateCustomFields, {field_type: 'contacts'});
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    createTask() {
      this.$refs.TaskFieldLabelsRef.createTask();
    },

    deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
    changeDeliverableType(deliverable, type) {
			if (deliverable.deliverable_template_id == type.typeId) return;
			this.$store.dispatch('changeDeliverableType', {
				id: deliverable.id,
				deliverable_type: type.id,
			});
		},
    updateTabIndex() {
      const normalizedTabIndex = Number(this.tabIndex ?? 0);
      this.currentTab = Number.isFinite(normalizedTabIndex) ? normalizedTabIndex : 0;
    },

    scrollToHighlightedTask() {
      this.$nextTick(() => {
        const wrapper = this.$refs.refTaskFieldsWrapper;
        if (!wrapper) return;

        // Allow the modal + task list to render before scrolling.
        setTimeout(() => {
          const highlighted = wrapper.querySelector('.task-fields .field-block.highlight');
          if (highlighted && highlighted.scrollIntoView) {
            highlighted.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 250);
      });
    },

  },

  watch: {
    tabIndex: {
      immediate: true,
      handler() {
        this.updateTabIndex();
      },
    },
    tasksToHighlight(newTasks) {
      if (Array.isArray(newTasks) && newTasks.length) {
        this.scrollToHighlightedTask();
      }
    },
    taskHighlighted(newTaskId) {
      if (newTaskId) {
        this.scrollToHighlightedTask();
      }
    },
  },


  mounted() {
    $('#editDeliverableModal .modal-content').removeAttr('tabindex');
    if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) {
      $('.add-contact-button, .add-resource-button').removeAttr('title').attr('disabled', 'disabled');
    }
    // let that = this;
    // this.$nextTick(function () {
    //   that.updateTabIndex();
    //   setTimeout(function () {
    //     if (that.deliverableDetail.deliverableId !== undefined) {
    //       // call api to read all alerts after 10 seconds
    //       that.$store.dispatch(
    //         'makeAllRelatedAlertRead',
    //         {
    //           groupedModelId: that.deliverableDetail.deliverableId
    //         }
    //       );
    //     }
    //   }, 10000);
    // });
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

</style>
